"use strict";
import _classes from "./utility.module.css.js";
const utilClasses = {
  center: _classes.center,
  hideVisually: _classes["hide-visually"],
  hideScrollbar: _classes["hide-scrollbar"],
  focusVisible: _classes["focus-visible"],
  focusVisibleInset: _classes["focus-visible-inset"]
};
export {
  utilClasses
};
